module.exports = __webpack_public_path__ + "img/porta-oberta.a9d46f98.png";